export enum ServiceSource {
  // SDK登录前
  BeforeLogin = "1",
  // SDK登录后进入游戏前
  AfterLogin = "2",
  // SDK进入游戏后
  EnterGame = "3",
  // 通用微信公众号
  CommonWeChat = "4",
  // 飞鱼游戏公众号
  FeiYuWeChat = "5",
  // PC端官网客服
  AppWeb = "6",
  // PC端企业客服
  CompnayWeb = "7",
}
